jQuery(function ($) {
  $(function () {
    var navBar = $("#main-nav");
    if (!navBar.length) return;

    var previousScroll = 0;
    var ticking = false;
    var navbarCollapse = $("#navbarNav");
    var navbarToggler = $(".navbar-toggler");

    function onScroll() {
      var currentScroll = $(window).scrollTop();
      if (currentScroll > 100 && currentScroll > previousScroll) {
        navBar.addClass("is-hidden");
      } else {
        navBar.removeClass("is-hidden");
      }

      // On small screens, close the mobile nav if it's open while scrolling
      if (window.innerWidth < 992 && navbarCollapse.hasClass("show")) {
        navbarCollapse.collapse("hide");
      }

      previousScroll = currentScroll;
      ticking = false;
    }

    $(window).on("scroll", function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(onScroll);
      }
    });

    // Close navbar when clicking outside
    $(document).on("click", function (event) {
      var navbarCollapse = $("#navbarNav");
      var navbarToggler = $(".navbar-toggler");

      if (
        navbarCollapse.hasClass("show") &&
        !$(event.target).closest(".navbar").length
      ) {
        navbarToggler.click();
      }
    });

    // Prevent closing when clicking inside the navbar
    $(".navbar").on("click", function (event) {
      event.stopPropagation();
    });
  });

  $(".hero-left-bottom-carousel").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });

  // Most Viewed carousel - screens below lg (< 992px)
  function initMostViewedCarousel() {
    var $carousel = $(".mostviewed-carousel");
    if (!$carousel.length) return;

    var isMobile = window.innerWidth < 992;

    if (isMobile && !$carousel.hasClass("owl-loaded")) {
      $carousel.addClass("owl-carousel owl-theme");
      $carousel.owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        dots: false,
        stagePadding: 80,
        responsive: {
          0: {
            items: 1,
            stagePadding: 60
          },
          576: {
            items: 1,
            stagePadding: 80
          }
        }
      });
    } else if (!isMobile && $carousel.hasClass("owl-loaded")) {
      $carousel.trigger("destroy.owl.carousel");
      $carousel.removeClass("owl-loaded owl-hidden");
      $carousel.removeClass("owl-carousel owl-theme");
      $carousel.find(".owl-stage-outer").children().unwrap();
    }
  }

  // Pictorial carousel - screens below lg (< 992px)
  function initPictorialCarousel() {
    var $carousel = $(".pictorial-carousel");
    if (!$carousel.length) return;

    var isMobile = window.innerWidth < 992;

    if (isMobile && !$carousel.hasClass("owl-loaded")) {
      $carousel.addClass("owl-carousel owl-theme");
      $carousel.owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        dots: false,
        stagePadding: 80,
        responsive: {
          0: {
            items: 1,
            stagePadding: 60
          },
          576: {
            items: 1,
            stagePadding: 80
          }
        }
      });
    } else if (!isMobile && $carousel.hasClass("owl-loaded")) {
      $carousel.trigger("destroy.owl.carousel");
      $carousel.removeClass("owl-loaded owl-hidden");
      $carousel.removeClass("owl-carousel owl-theme");
      $carousel.find(".owl-stage-outer").children().unwrap();
    }
  }

  // Video carousel - mobile only (below lg)
  function initVideoCarousel() {
    var $carousel = $(".video-mobile-carousel");
    if (!$carousel.length) return;

    var isMobile = window.innerWidth < 992;

    if (isMobile && !$carousel.hasClass("owl-loaded")) {
      $carousel.addClass("owl-carousel owl-theme");
      $carousel.owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        dots: false,
        stagePadding: 80,
        responsive: {
          0: {
            items: 1,
            stagePadding: 60
          },
          576: {
            items: 1,
            stagePadding: 80
          }
        }
      });
    } else if (!isMobile && $carousel.hasClass("owl-loaded")) {
      $carousel.trigger("destroy.owl.carousel");
      $carousel.removeClass("owl-loaded owl-hidden");
      $carousel.removeClass("owl-carousel owl-theme");
      $carousel.find(".owl-stage-outer").children().unwrap();
    }
  }

  // More From Author carousel - mobile only (below lg)
  function initMoreFromAuthorCarousel() {
    var $carousel = $(".morefromauthor-section-carousel-container .row");
    if (!$carousel.length) return;

    var isMobile = window.innerWidth < 992;

    if (isMobile && !$carousel.hasClass("owl-loaded")) {
      $carousel.addClass("owl-carousel owl-theme");
      $carousel.owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        dots: false,
        stagePadding: 80,
        responsive: {
          0: {
            items: 1,
            stagePadding: 60
          },
          576: {
            items: 1,
            stagePadding: 80
          }
        }
      });
    } else if (!isMobile && $carousel.hasClass("owl-loaded")) {
      $carousel.trigger("destroy.owl.carousel");
      $carousel.removeClass("owl-loaded owl-hidden");
      $carousel.removeClass("owl-carousel owl-theme");
      $carousel.find(".owl-stage-outer").children().unwrap();
    }
  }

  // Related Post carousel - mobile only (below lg)
  function initRelatedPostCarousel() {
    var $carousel = $(".relatedpost-section-carousel-container .row");
    if (!$carousel.length) return;

    var isMobile = window.innerWidth < 992;

    if (isMobile && !$carousel.hasClass("owl-loaded")) {
      $carousel.addClass("owl-carousel owl-theme");
      $carousel.owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        dots: false,
        stagePadding: 80,
        responsive: {
          0: {
            items: 1,
            stagePadding: 60
          },
          576: {
            items: 1,
            stagePadding: 80
          }
        }
      });
    } else if (!isMobile && $carousel.hasClass("owl-loaded")) {
      $carousel.trigger("destroy.owl.carousel");
      $carousel.removeClass("owl-loaded owl-hidden");
      $carousel.removeClass("owl-carousel owl-theme");
      $carousel.find(".owl-stage-outer").children().unwrap();
    }
  }

  // Initialize on load and on resize
  function initCarouselsMobileOnly() {
    initMostViewedCarousel();
    initPictorialCarousel();
    initVideoCarousel();
    initMoreFromAuthorCarousel();
    initRelatedPostCarousel();
  }

  initCarouselsMobileOnly();
  $(window).on("resize", function () {
    initCarouselsMobileOnly();
  });

  // Video Player Functionality
  $(function () {
    var videoContainer = $("#videoContainer");

    if (videoContainer.length) {
      var thumbnail = videoContainer.find(".video-thumbnail");
      var playButton = videoContainer.find(".play-button-wrapper");
      var iframe = videoContainer.find(".video-iframe");
      var videoBadge = videoContainer.find(".video-badge");

      function playVideo() {
        thumbnail.hide();
        playButton.hide();
        videoBadge.hide();

        iframe.show();
        var videoSrc = iframe.attr("data-src");
        iframe.attr("src", videoSrc + "?autoplay=1");
      }

      thumbnail.on("click", playVideo);
      playButton.on("click", playVideo);
    }
  });

  // GSAP ScrollTrigger animations for sections & video cards
  if (window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray("section.section").forEach(function (section) {
      gsap.from(section, {
        opacity: 0,
        y: 50,
        duration: 1.2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: section,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    });

    gsap.utils.toArray(".video-card").forEach(function (card) {
      gsap.from(card, {
        opacity: 0,
        y: 40,
        duration: 0.9,
        ease: "power2.out",
        scrollTrigger: {
          trigger: card,
          start: "top 85%",
          toggleActions: "play none none reverse"
        }
      });
    });

    gsap.utils.toArray(".pictorial-card").forEach(function (card) {
      gsap.from(card, {
        opacity: 0,
        y: 40,
        duration: 0.9,
        ease: "power2.out",
        scrollTrigger: {
          trigger: card,
          start: "top 85%",
          toggleActions: "play none none reverse"
        }
      });
    });

    gsap.utils.toArray(".author-card").forEach(function (card) {
      gsap.from(card, {
        opacity: 0,
        y: 40,
        duration: 0.9,
        ease: "power2.out",
        scrollTrigger: {
          trigger: card,
          start: "top 85%",
          toggleActions: "play none none reverse"
        }
      });
    });

    // GLightbox initialization for videos and pictorials
    if (typeof GLightbox !== 'undefined') {
      const lightbox = GLightbox({
        selector: '.glightbox',
        videosWidth: 900,
        videosHeight: 506
      });

      // Track video view on click
      $(document).on('click', '.video-link', function () {
        var postId = $(this).data('post-id');
        if (postId) {
          $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
              action: 'track_video_view',
              post_id: postId
            },
            success: function (response) {
              if (response.success) {
                var eyeSpan = $('.video-link[data-post-id="' + postId + '"]')
                  .closest('.video-card')
                  .find('.ri-eye-fill')
                  .parent();
                eyeSpan.html('<i class="ri-eye-fill"></i>' + response.data);
              }
            }
          });
        }
      });
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const searchIcon = document.querySelector('.search-icon');
  if (window.location.href.includes('?s=') || window.location.href.includes('/search/')) {
    searchIcon?.classList.add('active');
  }
});

document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth < 992) {

    document.querySelectorAll('.menu-item-has-children > .nav-link').forEach(function (el) {

      el.addEventListener('click', function (e) {
        e.preventDefault();
        let parent = this.parentElement;
        parent.classList.toggle('show');
      });

    });

  }

});

// Newsletter subscription form (Forminator shortcode [forminator_form id="381"])
// doesn't have a placeholder configured in Forminator, so set it here.
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.forminator-custom-form-381 .forminator-email--field').forEach(function (el) {
    el.setAttribute('placeholder', 'E-mail Address');
  });
});